/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-spacer[_ngcontent-%COMP%]{height:10px;width:10px}.nsc-spacer--sm[_ngcontent-%COMP%]{height:20px;width:20px}.nsc-spacer--xsm[_ngcontent-%COMP%]{height:5px;width:5px}.nsc-spacer--md[_ngcontent-%COMP%]{height:30px;width:30px}.nsc-spacer--lg[_ngcontent-%COMP%]{height:40px;width:40px}.nsc-spacer--horizontal[_ngcontent-%COMP%]{display:inline-block}"];
export { styles as styles };
